// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".popper-class .title-item[data-v-2d2bbdc2] {\n  overflow: hidden;\n  width: auto;\n  font-size: 0.875rem;\n  font-weight: inherit;\n  margin: 0 auto;\n}\n.title-item[data-v-2d2bbdc2] {\n  overflow: hidden;\n  width: 1.75rem;\n  font-size: 0.875rem;\n  font-weight: bold;\n  margin: 0 auto;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
